import type { JSMol, RDKitModule } from '@rdkit/rdkit';

export interface RdKitSmokeTestResult {
  readonly version: string;
  readonly canonicalSmiles: string;
}

interface RdKitInitializerOptions {
  locateFile?: (fileName: string) => string;
}

type RdKitInitializer = (options?: RdKitInitializerOptions) => Promise<RDKitModule>;

let rdKitPromise: Promise<RDKitModule> | undefined;

export function loadRdKit(): Promise<RDKitModule> {
  rdKitPromise ??= import('@rdkit/rdkit').then((imported) => {
    const initialize = imported.default as unknown as RdKitInitializer;
    return typeof window === 'undefined'
      ? initialize()
      : initialize({ locateFile: (fileName) => `/rdkit/${fileName}` });
  });
  return rdKitPromise;
}

export async function runRdKitSmokeTest(): Promise<RdKitSmokeTestResult> {
  const rdkit = await loadRdKit();
  const molecule: JSMol | null = rdkit.get_mol('CCO');
  if (!molecule) throw new Error('RDKit could not parse the ethanol smoke-test molecule.');
  try {
    return {
      version: rdkit.version(),
      canonicalSmiles: molecule.get_smiles()
    };
  } finally {
    molecule.delete();
  }
}
